const NotFound = () => {
  return (
    <div className="w-full h-screen bg-blue-100 flex justify-center items-center">
      <h1 className="text-2xl font-semibold text-blue-900">404 | Not Found</h1>
    </div>
  );
};

export default NotFound;
